// extracted by mini-css-extract-plugin
module.exports = {"wlzhmol":"wlzhmol","bsccpj7":"bsccpj7","i1ehbl6j":"i1ehbl6j"};